import React from "react";
import { Sparkles } from "lucide-react";

// Discreet badge shown over AI-generated images so readers know they're illustrative.
export const AiPhotoBadge = ({ className = "" }) => (
  <span
    data-testid="ai-photo-badge"
    title="Imagem ilustrativa gerada por IA"
    className={`absolute bottom-2 left-2 z-10 flex items-center gap-1 rounded-full bg-black/55 backdrop-blur-sm text-white text-[10px] font-medium px-2 py-0.5 pointer-events-none ${className}`}
  >
    <Sparkles className="w-3 h-3" /> Ilustração IA
  </span>
);

export default AiPhotoBadge;
